import EmployeeRoutes from "./modules/EmployeeRoutes"
import ModalityRoutes from "./modules/ModalityRoutes"
import ClientRoutes from "./modules/ClientRoutes"
import PaymentOptionRoutes from "./modules/PaymentOptionRoutes"
import SupplierRoutes from "./modules/SupplierRoutes"
import CompanyRoutes from "./modules/CompanyRoutes"
import BuildingRoutes from "./modules/BuildingRoutes"
import RegionRoutes from "./modules/RegionRoutes"
import DriverRoutes from "./modules/DriverRoutes"
import TruckRoutes from "./modules/TruckRoutes"
import ClientPortfolioRoutes from "./modules/ClientPortfolioRoutes"
import MainDailyRoutes from "./modules/MainDailyRoutes"
import PickupLocationRoutes from "./modules/PickupLocationRoutes"
import PalletsRoutes from "./modules/PalletsRoutes"
import EconomicGroupRoutes from "./modules/EconomicGroupRoutes"
import PaymentReminderSettingsRoutes from "./modules/PaymentReminderSettingsRoutes"
import WhatsappMessagesRoutes from "./modules/WhatsappMessagesRoutes"
import ShippingRateRoutes from "./modules/ShippingRateRoutes"

export default [
  ...EmployeeRoutes,
  ...ModalityRoutes,
  ...CompanyRoutes,
  ...BuildingRoutes,
  ...ClientRoutes,
  ...PaymentOptionRoutes,
  ...SupplierRoutes,
  ...RegionRoutes,
  ...DriverRoutes,
  ...TruckRoutes,
  ...ClientPortfolioRoutes,
  ...MainDailyRoutes,
  ...PickupLocationRoutes,
  ...EconomicGroupRoutes,
  ...PalletsRoutes,
  ...PaymentReminderSettingsRoutes,
  ...WhatsappMessagesRoutes,
  ...ShippingRateRoutes,
]